import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";
import ConfigApi from "@/api/Config";

class LoadingComponent {
  name: string = "";
  timestamp: Date | null = null;

  constructor(name: string) {
    this.name = name;
    this.timestamp = new Date();
  }
}

@Module({ namespaced: true })
export default class AppModule extends VuexModule {
  mode: string = "user";
  axiosLoading: number = 0;
  pageTitle: string = "";
  pageDescription: string = "";

  public canPublishReport: boolean = false;
  public canPublishPreliminaryReport: boolean = false;
  public canEditOrganizations: boolean = false;
  public reportYear: number = new Date().getFullYear();
  public isPreliminaryReportSent: boolean = false;
  public isReportSent: boolean = false;
  public organizations: any = {};

  @Mutation setLoading() {
    this.axiosLoading += 1;
  }

  @Mutation clearLoading() {
    this.axiosLoading -= 1;
  }

  @Mutation setMode(mode: string) {
    this.mode = mode;
  }

  @Mutation setPageTitle(title: string) {
    this.pageTitle = title;
  }

  @Mutation setPageDescription(description: string) {
    this.pageDescription = description;
  }

  @Mutation
  setCanPublishReport(value: boolean) {
    this.canPublishReport = value;
  }

  @Mutation
  setCanPublishPreliminaryReport(value: boolean) {
    this.canPublishPreliminaryReport = value;
  }

  @Mutation setIsPreliminaryReportSent(value: boolean) {
    this.isPreliminaryReportSent = value;
  }

  @Mutation setIsReportSent(value: boolean) {
    this.isReportSent = value;
  }

  @Mutation
  setCanEditOrganizations(value: boolean) {
    this.canEditOrganizations = value;
  }

  @Mutation
  setReportYear(value: number) {
    this.reportYear = value;
  }

  @Mutation
  setOrganizations(value: OrganizationList) {
    this.organizations = value;
  }

  get isLoading() {
    return !!this.axiosLoading;
  }

  get getMode() {
    return this.mode;
  }

  get isAdminMode() {
    return this.mode === "admin";
  }

  get isUserMode() {
    return this.mode === "user";
  }

  get isPublicMode() {
    return this.mode === "public";
  }

  @Action getConfig() {
    return ConfigApi.get().then((res: Config) => {
      if (res) {
        this.context.commit("setCanPublishReport", res.canPublishReport);
        this.context.commit(
          "setCanPublishPreliminaryReport",
          res.canPublishPreliminaryReport
        );
        this.context.commit(
          "setCanEditOrganizations",
          res.canEditOrganizations
        );
        this.context.commit("setReportYear", res.reportYear);
        this.context.commit(
          "setIsPreliminaryReportSent",
          res.isPreliminaryReportSent
        );
        this.context.commit("setOrganizations", res.organizations);
        this.context.commit("setIsReportSent", res.isReportSent);
      }
      return res;
    });
  }
}
